module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-7 clear-padding"
  }, [_c('div', {
    staticClass: "evaluation-wrapper"
  }, [_c('div', {
    staticClass: "evaluation-header clearfix cursor-pointer border-top-color-skin",
    on: {
      "click": _vm.togglePart1
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 clear-padding evaluation-score"
  }, [_vm._v("10/20")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.part1),
      expression: "part1"
    }],
    staticClass: "evaluation-body"
  }, [_c('div', {
    staticClass: "evaluation-section clearfix"
  }, [_c('div', {
    staticClass: "evaluation-item clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 subject"
  }, [_vm._v("\n                1. It is a long established fact that a reader will be distracted by the readable \n                content of a page when looking at its layout.\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 clear-padding"
  }, [_c('div', {
    staticClass: "special"
  }), _vm._v(" "), _c('div', {
    staticClass: "choice"
  }, [_c('div', {
    staticClass: "col-xs-12 clear-padding radio"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-md-11 box-label",
    class: {
      'border-color-skin': _vm.choice1Disp
    },
    on: {
      "click": _vm.toggleChoice1Disp
    }
  }, [_c('div', {
    staticClass: "main-label",
    class: {
      'active color-skin': _vm.choice1Disp
    }
  }, [_vm._v("A : ดีมาก (4 คะแนน)")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice1Disp),
      expression: "choice1Disp"
    }],
    staticClass: "more-label"
  }, [_vm._v("Contrary to popular belief, Lorem Ipsum is not simply random text.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 clear-padding radio"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-md-11 box-label",
    class: {
      'border-color-skin': _vm.choice2Disp
    },
    on: {
      "click": _vm.toggleChoice2Disp
    }
  }, [_c('div', {
    staticClass: "main-label",
    class: {
      'active color-skin': _vm.choice2Disp
    }
  }, [_vm._v("B : ดี (3 คะแนน)")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice2Disp),
      expression: "choice2Disp"
    }],
    staticClass: "more-label"
  }, [_vm._v("It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 clear-padding radio"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-md-11 box-label",
    class: {
      'border-color-skin': _vm.choice3Disp
    },
    on: {
      "click": _vm.toggleChoice3Disp
    }
  }, [_c('div', {
    staticClass: "main-label",
    class: {
      'active color-skin': _vm.choice3Disp
    }
  }, [_vm._v("C : ปานกลาง (2 คะแนน)")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice3Disp),
      expression: "choice3Disp"
    }],
    staticClass: "more-label"
  }, [_vm._v("Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 clear-padding radio"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-md-11 box-label",
    class: {
      'border-color-skin': _vm.choice4Disp
    },
    on: {
      "click": _vm.toggleChoice4Disp
    }
  }, [_c('div', {
    staticClass: "main-label",
    class: {
      'active color-skin': _vm.choice4Disp
    }
  }, [_vm._v("D : พอใช้ (1 คะแนน)")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice4Disp),
      expression: "choice4Disp"
    }],
    staticClass: "more-label"
  }, [_vm._v("Lorem Ipsum comes from sections 1.10.32 and 1.10.33.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 clear-padding radio"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-md-11 box-label",
    class: {
      'border-color-skin': _vm.choice5Disp
    },
    on: {
      "click": _vm.toggleChoice5Disp
    }
  }, [_c('div', {
    staticClass: "main-label",
    class: {
      'active color-skin': _vm.choice5Disp
    }
  }, [_vm._v("F : ต้องปรับปรุง (0 คะแนน)")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice5Disp),
      expression: "choice5Disp"
    }],
    staticClass: "more-label"
  }, [_vm._v("This book is a treatise on the theory of ethics, very popular during the Renaissance.")])])])])]), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "evaluation-section clearfix"
  }, [_c('div', {
    staticClass: "evaluation-item clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 subject"
  }, [_vm._v("\n                2. It is a long established fact that a reader will be distracted by the readable \n                content of a page when looking at its layout.\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 clear-padding"
  }, [_c('div', {
    staticClass: "special"
  }), _vm._v(" "), _c('div', {
    staticClass: "choice"
  }, [_c('div', {
    staticClass: "col-xs-12 clear-padding radio"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-md-11 box-label",
    class: {
      'border-color-skin': _vm.choice1Disp
    },
    on: {
      "click": _vm.toggleChoice1Disp
    }
  }, [_c('div', {
    staticClass: "main-label",
    class: {
      'active color-skin': _vm.choice1Disp
    }
  }, [_vm._v("A : ดีมาก (4 คะแนน)")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice1Disp),
      expression: "choice1Disp"
    }],
    staticClass: "more-label"
  }, [_vm._v("Contrary to popular belief, Lorem Ipsum is not simply random text.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 clear-padding radio"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-md-11 box-label",
    class: {
      'border-color-skin': _vm.choice2Disp
    },
    on: {
      "click": _vm.toggleChoice2Disp
    }
  }, [_c('div', {
    staticClass: "main-label",
    class: {
      'active color-skin': _vm.choice2Disp
    }
  }, [_vm._v("B : ดี (3 คะแนน)")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice2Disp),
      expression: "choice2Disp"
    }],
    staticClass: "more-label"
  }, [_vm._v("It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 clear-padding radio"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-md-11 box-label",
    class: {
      'border-color-skin': _vm.choice3Disp
    },
    on: {
      "click": _vm.toggleChoice3Disp
    }
  }, [_c('div', {
    staticClass: "main-label",
    class: {
      'active color-skin': _vm.choice3Disp
    }
  }, [_vm._v("C : ปานกลาง (2 คะแนน)")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice3Disp),
      expression: "choice3Disp"
    }],
    staticClass: "more-label"
  }, [_vm._v("Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 clear-padding radio"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-md-11 box-label",
    class: {
      'border-color-skin': _vm.choice4Disp
    },
    on: {
      "click": _vm.toggleChoice4Disp
    }
  }, [_c('div', {
    staticClass: "main-label",
    class: {
      'active color-skin': _vm.choice4Disp
    }
  }, [_vm._v("D : พอใช้ (1 คะแนน)")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice4Disp),
      expression: "choice4Disp"
    }],
    staticClass: "more-label"
  }, [_vm._v("Lorem Ipsum comes from sections 1.10.32 and 1.10.33.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 clear-padding radio"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-md-11 box-label",
    class: {
      'border-color-skin': _vm.choice5Disp
    },
    on: {
      "click": _vm.toggleChoice5Disp
    }
  }, [_c('div', {
    staticClass: "main-label",
    class: {
      'active color-skin': _vm.choice5Disp
    }
  }, [_vm._v("F : ต้องปรับปรุง (0 คะแนน)")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice5Disp),
      expression: "choice5Disp"
    }],
    staticClass: "more-label"
  }, [_vm._v("This book is a treatise on the theory of ethics, very popular during the Renaissance.")])])])])]), _vm._v(" "), _vm._m(12)])])])])]), _vm._v(" "), _vm._m(13)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8 clear-padding"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-3 clear-padding"
  }, [_vm._v("ส่วนที่ 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9 clear-padding evaluation-title"
  }, [_vm._v("Title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 col-md-1 clear-padding"
  }, [_c('input', {
    attrs: {
      "id": "radio-1",
      "name": "radio",
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "radio-1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 col-md-1 clear-padding"
  }, [_c('input', {
    attrs: {
      "id": "radio-2",
      "name": "radio",
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "radio-2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 col-md-1 clear-padding"
  }, [_c('input', {
    attrs: {
      "id": "radio-3",
      "name": "radio",
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "radio-3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 col-md-1 clear-padding"
  }, [_c('input', {
    attrs: {
      "id": "radio-4",
      "name": "radio",
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "radio-4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 col-md-1 clear-padding"
  }, [_c('input', {
    attrs: {
      "id": "radio-5",
      "name": "radio",
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "radio-5"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 clear-padding "
  }, [_c('div', {
    staticClass: "col-xs-12 clear-padding"
  }, [_c('div', {
    staticClass: "weight-box clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4 weight-content"
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" Weight : 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 weight-content"
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  }), _vm._v(" Score : 3")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 col-md-1 clear-padding"
  }, [_c('input', {
    attrs: {
      "id": "radio-1",
      "name": "radio",
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "radio-1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 col-md-1 clear-padding"
  }, [_c('input', {
    attrs: {
      "id": "radio-2",
      "name": "radio",
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "radio-2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 col-md-1 clear-padding"
  }, [_c('input', {
    attrs: {
      "id": "radio-3",
      "name": "radio",
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "radio-3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 col-md-1 clear-padding"
  }, [_c('input', {
    attrs: {
      "id": "radio-4",
      "name": "radio",
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "radio-4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 col-md-1 clear-padding"
  }, [_c('input', {
    attrs: {
      "id": "radio-5",
      "name": "radio",
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "radio-5"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 clear-padding "
  }, [_c('div', {
    staticClass: "col-xs-12 clear-padding"
  }, [_c('div', {
    staticClass: "weight-box clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4 weight-content"
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" Weight : 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 weight-content"
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  }), _vm._v(" Score : 3")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7 clear-padding"
  }, [_c('div', {
    staticClass: "evaluation-sum"
  }, [_vm._v("\n      รวม 50/40\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b400ea1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/evaluation/component.vue
// module id = 3605
// module chunks = 1